import themesConfig from 'app/configs/themesConfig';
import _ from 'lodash';

import { TagColor } from './ui';

export const ThemeMode = {
  LIGHT: 'light',
  DARK: 'dark',
};

export const themeOptions = [
  { name: 'Light', value: ThemeMode.LIGHT },
  { name: 'Dark', value: ThemeMode.DARK },
];

export const IS_SWITCH_THEME_MODE_ALLOWED = true;

export const DEFAULT_THEME_MODE = ThemeMode.LIGHT;

export const defaultThemeOptions = {
  typography: {
    fontFamily: ['Roboto', '"Helvetica"', 'Arial', 'sans-serif'].join(','),
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 600,
    useNextVariants: true,
    suppressDeprecationWarnings: true,
  },
};

export const mustHaveThemeOptions = {
  typography: {
    htmlFontSize: 10,
    body1: {
      fontSize: '1.4rem',
    },
    body2: {
      fontSize: '1.4rem',
    },
  },
  tag: {
    [TagColor.YELLOW]: '#FFED4A',
    [TagColor.GREEN]: '#38C172',
    [TagColor.BLUE]: '#1485E3',
    [TagColor.RED]: '#E3342F',
    [TagColor.PURPLE_DARK]: '#794ACF',
    [TagColor.PURPLE_LIGHT]: '#A779E9',
    [TagColor.INDIGO]: '#6574CD',
    [TagColor.GREY_DARK]: '#8795A1',
    [TagColor.ORANGE]: '#F6993F',
    [TagColor.ORANGE_DARK]: '#DE751F',
    [TagColor.PINK]: '#E55B5B',
  },
};

export const deprecatedThemesConfig = {
  mainThemeDark: _.merge({}, themesConfig.default, themesConfig.defaultDark, {
    palette: { type: ThemeMode.DARK },
  }),
  mainThemeLight: _.merge({}, themesConfig.default, themesConfig.mainThemeLight, {
    palette: { type: ThemeMode.LIGHT },
  }),
};
